import {CookBookStockModel} from './cook-book-stock.model';

export class CookBookItemModel {
  public static IRI = '/api/cook_book_items';
  cookBookStock: CookBookStockModel[];
  amount: number;
  id: number;
}
